import { render } from "./sdkPart.vue?vue&type=template&id=7e6f6e83&scoped=true"
import script from "./sdkPart.vue?vue&type=script&lang=js"
export * from "./sdkPart.vue?vue&type=script&lang=js"

import "./sdkPart.vue?vue&type=style&index=0&id=7e6f6e83&scoped=true&lang=less"

import exportComponent from "/root/drive/src/landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6f6e83"]])

export default __exports__